import { useState } from "react";
import { Box, Text, Input, Flex, Button } from "@chakra-ui/react";

const RadiusFilter = ({
  setGeoDistanceFilter,
  maxKm,
  customerGeoPoint,
}: any) => {
  const [localMaxKm, setLocalMaxKm] = useState(maxKm);

  const handleInputChange = (e: any) => {
    const value = e.target.value;
    if (value === "" || Number(value) >= 0) {
      setLocalMaxKm(value);
    }
  };

  const applyGeoDistanceFilter = () => {
    if (customerGeoPoint) {
      const filterStr = `location:(${customerGeoPoint?.latitude},${customerGeoPoint?.longitude},${localMaxKm} km)`;
      setGeoDistanceFilter(filterStr);
    }
  };

  const resetGeoDistanceFilter = () => {
    setLocalMaxKm("");
    setGeoDistanceFilter("");
  };

  return (
    <Box
      width="100%"
      px={4}
      py={5}
      bg="white"
      borderRadius="xl"
      boxShadow="md"
      fontFamily="'Nunito','Inter', sans-serif"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Text
        fontWeight="900"
        fontSize="sm"
        mb={2}
        color="gray.700"
        textAlign="left"
      >
        Radius (in KMs)
      </Text>

      <Input
        placeholder="e.g. 5"
        type="number"
        size="sm"
        value={localMaxKm}
        onChange={handleInputChange}
        bg="gray.50"
        color="gray.700"
        borderRadius="lg"
        _placeholder={{ color: "gray.400" }}
        _hover={{ borderColor: "blue.400", bg: "gray.100" }}
        _focus={{
          bg: "white",
          boxShadow: "0 0 0 3px rgba(66, 153, 225, 0.3)",
        }}
        mb={4}
      />

      <Flex direction="row" justify="space-between" gap={2} align="stretch">
        <Button
          size="sm"
          colorScheme="blue"
          onClick={applyGeoDistanceFilter}
          isDisabled={!localMaxKm || Number(localMaxKm) <= 0}
          borderRadius="lg"
          flex={1}
          bg="#4b85f2"
        >
          Go
        </Button>
        <Button
          size="sm"
          variant="ghost"
          color="#4b85f2"
          onClick={resetGeoDistanceFilter}
          borderRadius="lg"
          flex={1}
        >
          Reset
        </Button>
      </Flex>
    </Box>
  );
};

export default RadiusFilter;
